import ajax from '../../../utils/ajax'
import Advice from './advice'


$(()=>{
    //显示信息列表
    let parent_id =  window.parentId ? window.parentId :  "msg-list" ;
    let toolbar_id = window.toolbarId ? window.toolbarId: "page-toolbar"
    let advice = new Advice(parent_id);
    advice.setToolbar(toolbar_id);
    $("#btn_search").click(()=>{
        let topic = $.trim($("#topic").val() ); 
        let category = $.trim($("#category").val() ); 
        let wenhao =  $.trim( $("#wenhao").val() );
    
        if(topic == "请输入标题"){
            topic = ""
        }
        if(wenhao == "请输入文号"){
            wenhao = "";
        }
        let data = {
            channelId: $("#channelId").val(),
            topic: topic,
            z5: wenhao ,
            category: category
        }
        for(var i  = 1 ;i < 40 ; i ++){
            if(i == 5){ //跳过文号:z5
                continue;
            }
            var obj =  document.getElementById("z" + i);
            if(obj){
                var val = $.trim($(obj).val())
                if(val && val.length > 0){
                    data['z' + i] = val;
                }
            }
        }
        advice.setData(data)
        advice.list();
    });
});


